import React from 'react';
import { auth } from '../../Api';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import './site.scss';

const FONT_LINK_ID = 'mob-font-inter';

// The fonts from Google Fonts (the pages use Inter), added once when a public page first opens; the admin pages do not
// use them
export function loadSiteFont() {
	if (typeof document === 'undefined' || document.getElementById(FONT_LINK_ID)) {
		return;
	}
	const link = document.createElement('link');
	link.id = FONT_LINK_ID;
	link.rel = 'stylesheet';
	// The main website's own font address, so the header and footer render with the very same font files
	link.href = 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap';
	document.head.appendChild(link);
}

/**
 * A public page (sign-up, sign-in, Terms and Conditions) in the Mobiliis design: the main website's header and footer
 * around it (SiteHeader, SiteFooter). Everything it shows is inside .mob-site, so its styles (site.scss) never reach the
 * signed-in admin pages. Whether sign-up is open (for the header's "Start free trial") comes from signupInfo when the
 * page has it already, otherwise it is asked here (signup/info).
 * props: page ('signup' | 'login' | 'terms'), signupInfo (optional), children
 */
class SiteLayout extends React.Component {
	constructor(props) {
		super(props);
		this.state = { signupInfo: null };
	}

	componentDidMount() {
		loadSiteFont();
		if (this.props.signupInfo === undefined && this.props.page !== 'terms') {
			auth.getSignupInfo()
				.then((res) => {
					if (!this.unmounted && res && res.data && res.data.code == 200) {
						this.setState({ signupInfo: res.data });
					}
				})
				.catch(() => {});
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	render() {
		const { page, children } = this.props;
		const signupInfo = this.props.signupInfo !== undefined ? this.props.signupInfo : this.state.signupInfo;
		return (
			<div className="mob-site">
				<SiteHeader page={page} signupInfo={signupInfo} />
				<main className="mob-main">
					<div className="mob-wrap">{children}</div>
				</main>
				<SiteFooter />
			</div>
		);
	}
}

export default SiteLayout;
